var map = {
	"./DSC04065.jpg": 127,
	"./DSC04068.jpg": 128,
	"./DSC04138.jpg": 129,
	"./DSC04148-2.jpg": 130,
	"./DSC04194.jpg": 131,
	"./DSC04200.jpg": 132,
	"./DSC04227-2.jpg": 133,
	"./DSC04241.jpg": 134,
	"./DSC04255.jpg": 135,
	"./DSC04262.jpg": 136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 126;